import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  adminLoginReducer,
  forgotpasswordReducer,
  resetpasswordReducer,
  userViewReducer,
  accreditedInvestorReducer,
  countryListReducer,
  currencyListReducer,
  userInvestmentViewReducer,
  ViewFollowersDetailsReducer,
} from "./redux/reducers/adminReducers";
import {
  campaignViewReducer,
  categoryViewReducer,
  teamViewReducer,
  partnerViewReducer,
  storyViewReducer,
  contentViewReducer,
  advisoryViewReducer,
  languageViewReducer,
  contactViewReducer,
  adminViewReducer,
  transactionViewReducer,
  partnerscontactViewReducer,
  featureViewReducer,
  faqViewReducer,
} from "./redux/reducers/campaignReducers";
import { dealFlowReducer } from "./redux/reducers/dealFlowReducer";

const reducer = combineReducers({
  //this will contain our reducers
  adminLogin: adminLoginReducer,
  forgotPassword: forgotpasswordReducer,
  resetPassword: resetpasswordReducer,
  campaignView: campaignViewReducer,
  categoryView: categoryViewReducer,
  teamView: teamViewReducer,
  featureView: featureViewReducer,
  partnerView: partnerViewReducer,
  userView: userViewReducer,
  accreditedView: accreditedInvestorReducer,
  storyView: storyViewReducer,
  contentView: contentViewReducer,
  advisoryView: advisoryViewReducer,
  languageView: languageViewReducer,
  contactView: contactViewReducer,
  adminView: adminViewReducer,
  transactionView: transactionViewReducer,
  contactPartnerView: partnerscontactViewReducer,
  countryListView: countryListReducer,
  currencyListView: currencyListReducer,
  userInvestment: userInvestmentViewReducer,
  ViewFollowersDetails: ViewFollowersDetailsReducer,
  faqView: faqViewReducer,
  // Deal Flow - Admin rating and interest stats
  dealFlow: dealFlowReducer,
});

const adminInfo = localStorage.getItem("admin")
  ? JSON.parse(localStorage.getItem("admin"))
  : null;

const initialState = {
  adminLogin: { user: adminInfo },
};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
